export { default as Img200 } from './processed/200/Suits_S8.jpg';
export { default as Img400 } from './processed/400/Suits_S8.jpg';
export { default as Imgthumb } from './processed/thumb/Suits_S8.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Suits_S8.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Suits_S8.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      144,
      61,
      84
    ],
    "_population": 5,
    "_hsl": [
      0.9538152610441767,
      0.4048780487804877,
      0.4019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      220,
      185,
      163
    ],
    "_population": 10,
    "_hsl": [
      0.06432748538011696,
      0.4488188976377955,
      0.7509803921568627
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      85,
      30,
      40
    ],
    "_population": 64,
    "_hsl": [
      0.9696969696969697,
      0.4782608695652174,
      0.22549019607843135
    ]
  },
  "Muted": {
    "_rgb": [
      148,
      111,
      81
    ],
    "_population": 81,
    "_hsl": [
      0.07462686567164178,
      0.29257641921397387,
      0.44901960784313727
    ]
  },
  "LightMuted": {
    "_rgb": [
      164,
      172,
      204
    ],
    "_population": 2,
    "_hsl": [
      0.6333333333333333,
      0.2816901408450705,
      0.7215686274509805
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      56,
      50
    ],
    "_population": 278,
    "_hsl": [
      0.028571428571428577,
      0.25925925925925924,
      0.2647058823529412
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Suits_S8.js